import { z } from "zod";

import { safeString } from "@/schema/public/components/base/safe-string.schema";

export const keyLearningPointsSchema = z.object({
  key_learning_point: safeString,
});

export type KeyLearningPoints = z.infer<typeof keyLearningPointsSchema>;

export const keyLearningPointsSchemaCamel = z.object({
  keyLearningPoint: z.string(),
});
export type KeyLearningPointsCamel = z.infer<
  typeof keyLearningPointsSchemaCamel
>;
